import { Component } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
    selector: 'app-notification-demo',
    templateUrl: './notification-demo.component.html',
    styleUrls: ['./notification-demo.component.scss']
})
export class NotificationDemoComponent {
    progressId = 'progress-notification';
    progressActive = false;
    progressValue = 0;
    progressInterval: any;

    constructor(private toastService: ToastService) { }

    showSuccessNotification(): void {
        this.toastService.showSuccess('Operação realizada com sucesso!');
    }

    showSuccessHtmlNotification(): void {
        this.toastService.showSuccess(
            '<strong>Sucesso!</strong> Operação realizada com <em>êxito</em>.',
            { enableHtml: true }
        );
    }

    showErrorNotification(): void {
        this.toastService.showError('Não foi possível completar a operação. Tente novamente.');
    }

    showWarnNotification(): void {
        this.toastService.showWarn('Esta ação pode resultar em perda de dados.');
    }

    showWarnWithAction(): void {
        this.toastService.showWarn(
            'Deseja continuar mesmo assim?',
            {
                title: 'Atenção',
                timer: 10000,
            },
            () => {
                this.toastService.showSuccess('Ação confirmada!');
            }
        );
    }

    showPermissionNotification(): void {
        this.toastService.showPermission('excluir registros');
    }

    showInternalErrorNotification(): void {
        this.toastService.showInternal();
    }

    showCustomInternalError(): void {
        this.toastService.showInternal(
            'Erro ao processar sua solicitação. O servidor está indisponível.',
            {
                title: 'Erro de conexão',
            },
            () => {
                this.toastService.showInfo('Tentando novamente...');
                setTimeout(() => {
                    this.toastService.showSuccess('Conexão restabelecida!');
                }, 2000);
            }
        );
    }

    showProgressNotification(): void {
        if (this.progressActive) {
            this.stopProgressNotification();
            return;
        }

        this.progressActive = true;
        this.progressValue = 0;

        // Iniciar toast de progresso
        this.toastService.showInfo(
            'Iniciando processamento...',
            {
                id: this.progressId,
                timer: null, // Não fecha automaticamente
                title: 'Progresso',
            }
        );

        // Simular progresso
        this.progressInterval = setInterval(() => {
            this.progressValue += 10;

            if (this.progressValue < 100) {
                this.toastService.updateInfo(
                    this.progressId,
                    `Processamento ${this.progressValue}% concluído...`
                );
            } else {
                this.toastService.updateInfo(
                    this.progressId,
                    'Processamento concluído!'
                );

                setTimeout(() => {
                    this.toastService.closeToast(this.progressId);
                    this.stopProgressNotification();
                }, 1500);
            }
        }, 1000);
    }

    private stopProgressNotification(): void {
        this.progressActive = false;
        this.progressValue = 0;
        clearInterval(this.progressInterval);
        this.toastService.closeToast(this.progressId);
    }
} 